import type * as Types from '@hotelplan/supergraph-api';

import type { DocumentNode } from 'graphql';
import { FdrImageFragmentDoc } from 'schemas/fragment/regular/fdrImage.generated';
import { FdrResizedFragmentDoc } from 'schemas/fragment/regular/fdrResized.generated';
import { FdrCoordinatesFragmentDoc } from 'schemas/fragment/geo/fdrCoordinates.generated';
import { FdrProductWebMetaFragmentDoc } from 'schemas/fragment/web-meta/fdr-product-web-meta.generated';
import { FdrProductInfoB2bFragmentDoc } from 'schemas/fragment/product/fdr-product-info-b2b.generated';
import { FdrAdventureTravelRouteFragmentDoc } from 'schemas/fragment/product/fdr-adventure-travel-route.generated';
import type * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@hotelplan/fdr.lib.apollo.query';
const defaultOptions = {} as const;
export type FdrGeoMapProductsQueryVariables = Types.Exact<{
  input: Types.FdrGeoInput;
  productLimit: Types.Scalars['Int'];
  imageCriteria: Array<Types.FdrImageCriteria> | Types.FdrImageCriteria;
}>;

export type FdrGeoMapProductsQuery = {
  __typename?: 'Query';
  fdrGeo?:
    | {
        __typename: 'FdrContinent';
        id: string;
        adventureTravels: {
          __typename?: 'FdrGeoProducts';
          productsPage?: Array<
            | {
                __typename: 'FdrAdventureTravel';
                name: string;
                id: string;
                headerImages?: Array<{
                  __typename?: 'FdrImage';
                  alt: string;
                  description?: string | null;
                  copyright?: string | null;
                  rawUrl: string;
                  resized: Array<{
                    __typename?: 'FdrResizedImage';
                    id: string;
                    link: {
                      __typename?: 'FdrLink';
                      openMethod?: Types.FdrLinkOpenMethod | null;
                      legacyUrl?: string | null;
                      type: Types.FdrLinkType;
                      url: string;
                    };
                  }>;
                }> | null;
                route?: Array<{
                  __typename?: 'FdrAdventureTravelRoutePoint';
                  locationName: string;
                  coordinates: {
                    __typename?: 'FdrCoordinates';
                    latitude: number;
                    longitude: number;
                  };
                }> | null;
                webMeta: {
                  __typename?: 'FdrProductWebMeta';
                  meta?: {
                    __typename?: 'FdrMeta';
                    title: string;
                    description: string;
                    index: boolean;
                    noFollow: boolean;
                    sitemap: boolean;
                    link: {
                      __typename?: 'FdrLink';
                      openMethod?: Types.FdrLinkOpenMethod | null;
                      legacyUrl?: string | null;
                      type: Types.FdrLinkType;
                      url: string;
                    };
                  } | null;
                };
                productInfoB2B?: {
                  __typename?: 'ProductInfoB2B';
                  route?: string | null;
                  duration: string;
                  priceFrom?: string | null;
                  typeFlags?: Array<string> | null;
                } | null;
              }
            | { __typename: 'FdrCruise' }
            | { __typename: 'FdrHotel' }
            | { __typename: 'FdrRoundTrip' }
          > | null;
        };
        roundtrips: {
          __typename?: 'FdrGeoProducts';
          productsPage?: Array<
            | { __typename: 'FdrAdventureTravel' }
            | { __typename: 'FdrCruise' }
            | { __typename: 'FdrHotel' }
            | {
                __typename: 'FdrRoundTrip';
                name: string;
                id: string;
                hero?: {
                  __typename?: 'FdrImage';
                  alt: string;
                  description?: string | null;
                  copyright?: string | null;
                  rawUrl: string;
                  resized: Array<{
                    __typename?: 'FdrResizedImage';
                    id: string;
                    link: {
                      __typename?: 'FdrLink';
                      openMethod?: Types.FdrLinkOpenMethod | null;
                      legacyUrl?: string | null;
                      type: Types.FdrLinkType;
                      url: string;
                    };
                  }>;
                } | null;
                destination: {
                  __typename?: 'FdrDestination';
                  id: string;
                  coordinates?: {
                    __typename?: 'FdrCoordinates';
                    latitude: number;
                    longitude: number;
                  } | null;
                };
                webMeta: {
                  __typename?: 'FdrProductWebMeta';
                  meta?: {
                    __typename?: 'FdrMeta';
                    title: string;
                    description: string;
                    index: boolean;
                    noFollow: boolean;
                    sitemap: boolean;
                    link: {
                      __typename?: 'FdrLink';
                      openMethod?: Types.FdrLinkOpenMethod | null;
                      legacyUrl?: string | null;
                      type: Types.FdrLinkType;
                      url: string;
                    };
                  } | null;
                };
                productInfoB2B?: {
                  __typename?: 'ProductInfoB2B';
                  route?: string | null;
                  duration: string;
                  priceFrom?: string | null;
                  typeFlags?: Array<string> | null;
                } | null;
              }
          > | null;
        };
      }
    | {
        __typename: 'FdrCountry';
        id: string;
        adventureTravels: {
          __typename?: 'FdrGeoProducts';
          productsPage?: Array<
            | {
                __typename: 'FdrAdventureTravel';
                name: string;
                id: string;
                headerImages?: Array<{
                  __typename?: 'FdrImage';
                  alt: string;
                  description?: string | null;
                  copyright?: string | null;
                  rawUrl: string;
                  resized: Array<{
                    __typename?: 'FdrResizedImage';
                    id: string;
                    link: {
                      __typename?: 'FdrLink';
                      openMethod?: Types.FdrLinkOpenMethod | null;
                      legacyUrl?: string | null;
                      type: Types.FdrLinkType;
                      url: string;
                    };
                  }>;
                }> | null;
                route?: Array<{
                  __typename?: 'FdrAdventureTravelRoutePoint';
                  locationName: string;
                  coordinates: {
                    __typename?: 'FdrCoordinates';
                    latitude: number;
                    longitude: number;
                  };
                }> | null;
                webMeta: {
                  __typename?: 'FdrProductWebMeta';
                  meta?: {
                    __typename?: 'FdrMeta';
                    title: string;
                    description: string;
                    index: boolean;
                    noFollow: boolean;
                    sitemap: boolean;
                    link: {
                      __typename?: 'FdrLink';
                      openMethod?: Types.FdrLinkOpenMethod | null;
                      legacyUrl?: string | null;
                      type: Types.FdrLinkType;
                      url: string;
                    };
                  } | null;
                };
                productInfoB2B?: {
                  __typename?: 'ProductInfoB2B';
                  route?: string | null;
                  duration: string;
                  priceFrom?: string | null;
                  typeFlags?: Array<string> | null;
                } | null;
              }
            | { __typename: 'FdrCruise' }
            | { __typename: 'FdrHotel' }
            | { __typename: 'FdrRoundTrip' }
          > | null;
        };
        roundtrips: {
          __typename?: 'FdrGeoProducts';
          productsPage?: Array<
            | { __typename: 'FdrAdventureTravel' }
            | { __typename: 'FdrCruise' }
            | { __typename: 'FdrHotel' }
            | {
                __typename: 'FdrRoundTrip';
                name: string;
                id: string;
                hero?: {
                  __typename?: 'FdrImage';
                  alt: string;
                  description?: string | null;
                  copyright?: string | null;
                  rawUrl: string;
                  resized: Array<{
                    __typename?: 'FdrResizedImage';
                    id: string;
                    link: {
                      __typename?: 'FdrLink';
                      openMethod?: Types.FdrLinkOpenMethod | null;
                      legacyUrl?: string | null;
                      type: Types.FdrLinkType;
                      url: string;
                    };
                  }>;
                } | null;
                destination: {
                  __typename?: 'FdrDestination';
                  id: string;
                  coordinates?: {
                    __typename?: 'FdrCoordinates';
                    latitude: number;
                    longitude: number;
                  } | null;
                };
                webMeta: {
                  __typename?: 'FdrProductWebMeta';
                  meta?: {
                    __typename?: 'FdrMeta';
                    title: string;
                    description: string;
                    index: boolean;
                    noFollow: boolean;
                    sitemap: boolean;
                    link: {
                      __typename?: 'FdrLink';
                      openMethod?: Types.FdrLinkOpenMethod | null;
                      legacyUrl?: string | null;
                      type: Types.FdrLinkType;
                      url: string;
                    };
                  } | null;
                };
                productInfoB2B?: {
                  __typename?: 'ProductInfoB2B';
                  route?: string | null;
                  duration: string;
                  priceFrom?: string | null;
                  typeFlags?: Array<string> | null;
                } | null;
              }
          > | null;
        };
      }
    | {
        __typename: 'FdrCountryGroup';
        id: string;
        adventureTravels: {
          __typename?: 'FdrGeoProducts';
          productsPage?: Array<
            | {
                __typename: 'FdrAdventureTravel';
                name: string;
                id: string;
                headerImages?: Array<{
                  __typename?: 'FdrImage';
                  alt: string;
                  description?: string | null;
                  copyright?: string | null;
                  rawUrl: string;
                  resized: Array<{
                    __typename?: 'FdrResizedImage';
                    id: string;
                    link: {
                      __typename?: 'FdrLink';
                      openMethod?: Types.FdrLinkOpenMethod | null;
                      legacyUrl?: string | null;
                      type: Types.FdrLinkType;
                      url: string;
                    };
                  }>;
                }> | null;
                route?: Array<{
                  __typename?: 'FdrAdventureTravelRoutePoint';
                  locationName: string;
                  coordinates: {
                    __typename?: 'FdrCoordinates';
                    latitude: number;
                    longitude: number;
                  };
                }> | null;
                webMeta: {
                  __typename?: 'FdrProductWebMeta';
                  meta?: {
                    __typename?: 'FdrMeta';
                    title: string;
                    description: string;
                    index: boolean;
                    noFollow: boolean;
                    sitemap: boolean;
                    link: {
                      __typename?: 'FdrLink';
                      openMethod?: Types.FdrLinkOpenMethod | null;
                      legacyUrl?: string | null;
                      type: Types.FdrLinkType;
                      url: string;
                    };
                  } | null;
                };
                productInfoB2B?: {
                  __typename?: 'ProductInfoB2B';
                  route?: string | null;
                  duration: string;
                  priceFrom?: string | null;
                  typeFlags?: Array<string> | null;
                } | null;
              }
            | { __typename: 'FdrCruise' }
            | { __typename: 'FdrHotel' }
            | { __typename: 'FdrRoundTrip' }
          > | null;
        };
        roundtrips: {
          __typename?: 'FdrGeoProducts';
          productsPage?: Array<
            | { __typename: 'FdrAdventureTravel' }
            | { __typename: 'FdrCruise' }
            | { __typename: 'FdrHotel' }
            | {
                __typename: 'FdrRoundTrip';
                name: string;
                id: string;
                hero?: {
                  __typename?: 'FdrImage';
                  alt: string;
                  description?: string | null;
                  copyright?: string | null;
                  rawUrl: string;
                  resized: Array<{
                    __typename?: 'FdrResizedImage';
                    id: string;
                    link: {
                      __typename?: 'FdrLink';
                      openMethod?: Types.FdrLinkOpenMethod | null;
                      legacyUrl?: string | null;
                      type: Types.FdrLinkType;
                      url: string;
                    };
                  }>;
                } | null;
                destination: {
                  __typename?: 'FdrDestination';
                  id: string;
                  coordinates?: {
                    __typename?: 'FdrCoordinates';
                    latitude: number;
                    longitude: number;
                  } | null;
                };
                webMeta: {
                  __typename?: 'FdrProductWebMeta';
                  meta?: {
                    __typename?: 'FdrMeta';
                    title: string;
                    description: string;
                    index: boolean;
                    noFollow: boolean;
                    sitemap: boolean;
                    link: {
                      __typename?: 'FdrLink';
                      openMethod?: Types.FdrLinkOpenMethod | null;
                      legacyUrl?: string | null;
                      type: Types.FdrLinkType;
                      url: string;
                    };
                  } | null;
                };
                productInfoB2B?: {
                  __typename?: 'ProductInfoB2B';
                  route?: string | null;
                  duration: string;
                  priceFrom?: string | null;
                  typeFlags?: Array<string> | null;
                } | null;
              }
          > | null;
        };
      }
    | { __typename: 'FdrDestination'; id: string }
    | {
        __typename: 'FdrRegion';
        id: string;
        adventureTravels: {
          __typename?: 'FdrGeoProducts';
          productsPage?: Array<
            | {
                __typename: 'FdrAdventureTravel';
                name: string;
                id: string;
                headerImages?: Array<{
                  __typename?: 'FdrImage';
                  alt: string;
                  description?: string | null;
                  copyright?: string | null;
                  rawUrl: string;
                  resized: Array<{
                    __typename?: 'FdrResizedImage';
                    id: string;
                    link: {
                      __typename?: 'FdrLink';
                      openMethod?: Types.FdrLinkOpenMethod | null;
                      legacyUrl?: string | null;
                      type: Types.FdrLinkType;
                      url: string;
                    };
                  }>;
                }> | null;
                route?: Array<{
                  __typename?: 'FdrAdventureTravelRoutePoint';
                  locationName: string;
                  coordinates: {
                    __typename?: 'FdrCoordinates';
                    latitude: number;
                    longitude: number;
                  };
                }> | null;
                webMeta: {
                  __typename?: 'FdrProductWebMeta';
                  meta?: {
                    __typename?: 'FdrMeta';
                    title: string;
                    description: string;
                    index: boolean;
                    noFollow: boolean;
                    sitemap: boolean;
                    link: {
                      __typename?: 'FdrLink';
                      openMethod?: Types.FdrLinkOpenMethod | null;
                      legacyUrl?: string | null;
                      type: Types.FdrLinkType;
                      url: string;
                    };
                  } | null;
                };
                productInfoB2B?: {
                  __typename?: 'ProductInfoB2B';
                  route?: string | null;
                  duration: string;
                  priceFrom?: string | null;
                  typeFlags?: Array<string> | null;
                } | null;
              }
            | { __typename: 'FdrCruise' }
            | { __typename: 'FdrHotel' }
            | { __typename: 'FdrRoundTrip' }
          > | null;
        };
        roundtrips: {
          __typename?: 'FdrGeoProducts';
          productsPage?: Array<
            | { __typename: 'FdrAdventureTravel' }
            | { __typename: 'FdrCruise' }
            | { __typename: 'FdrHotel' }
            | {
                __typename: 'FdrRoundTrip';
                name: string;
                id: string;
                hero?: {
                  __typename?: 'FdrImage';
                  alt: string;
                  description?: string | null;
                  copyright?: string | null;
                  rawUrl: string;
                  resized: Array<{
                    __typename?: 'FdrResizedImage';
                    id: string;
                    link: {
                      __typename?: 'FdrLink';
                      openMethod?: Types.FdrLinkOpenMethod | null;
                      legacyUrl?: string | null;
                      type: Types.FdrLinkType;
                      url: string;
                    };
                  }>;
                } | null;
                destination: {
                  __typename?: 'FdrDestination';
                  id: string;
                  coordinates?: {
                    __typename?: 'FdrCoordinates';
                    latitude: number;
                    longitude: number;
                  } | null;
                };
                webMeta: {
                  __typename?: 'FdrProductWebMeta';
                  meta?: {
                    __typename?: 'FdrMeta';
                    title: string;
                    description: string;
                    index: boolean;
                    noFollow: boolean;
                    sitemap: boolean;
                    link: {
                      __typename?: 'FdrLink';
                      openMethod?: Types.FdrLinkOpenMethod | null;
                      legacyUrl?: string | null;
                      type: Types.FdrLinkType;
                      url: string;
                    };
                  } | null;
                };
                productInfoB2B?: {
                  __typename?: 'ProductInfoB2B';
                  route?: string | null;
                  duration: string;
                  priceFrom?: string | null;
                  typeFlags?: Array<string> | null;
                } | null;
              }
          > | null;
        };
      }
    | { __typename: 'FdrResort'; id: string }
    | null;
};

export type FdrGeoMapRoundTripFragment = {
  __typename?: 'FdrRoundTrip';
  name: string;
  id: string;
  hero?: {
    __typename?: 'FdrImage';
    alt: string;
    description?: string | null;
    copyright?: string | null;
    rawUrl: string;
    resized: Array<{
      __typename?: 'FdrResizedImage';
      id: string;
      link: {
        __typename?: 'FdrLink';
        openMethod?: Types.FdrLinkOpenMethod | null;
        legacyUrl?: string | null;
        type: Types.FdrLinkType;
        url: string;
      };
    }>;
  } | null;
  destination: {
    __typename?: 'FdrDestination';
    id: string;
    coordinates?: {
      __typename?: 'FdrCoordinates';
      latitude: number;
      longitude: number;
    } | null;
  };
  webMeta: {
    __typename?: 'FdrProductWebMeta';
    meta?: {
      __typename?: 'FdrMeta';
      title: string;
      description: string;
      index: boolean;
      noFollow: boolean;
      sitemap: boolean;
      link: {
        __typename?: 'FdrLink';
        openMethod?: Types.FdrLinkOpenMethod | null;
        legacyUrl?: string | null;
        type: Types.FdrLinkType;
        url: string;
      };
    } | null;
  };
  productInfoB2B?: {
    __typename?: 'ProductInfoB2B';
    route?: string | null;
    duration: string;
    priceFrom?: string | null;
    typeFlags?: Array<string> | null;
  } | null;
};

export type FdrGeoMapAdventureTravelFragment = {
  __typename?: 'FdrAdventureTravel';
  name: string;
  id: string;
  headerImages?: Array<{
    __typename?: 'FdrImage';
    alt: string;
    description?: string | null;
    copyright?: string | null;
    rawUrl: string;
    resized: Array<{
      __typename?: 'FdrResizedImage';
      id: string;
      link: {
        __typename?: 'FdrLink';
        openMethod?: Types.FdrLinkOpenMethod | null;
        legacyUrl?: string | null;
        type: Types.FdrLinkType;
        url: string;
      };
    }>;
  }> | null;
  route?: Array<{
    __typename?: 'FdrAdventureTravelRoutePoint';
    locationName: string;
    coordinates: {
      __typename?: 'FdrCoordinates';
      latitude: number;
      longitude: number;
    };
  }> | null;
  webMeta: {
    __typename?: 'FdrProductWebMeta';
    meta?: {
      __typename?: 'FdrMeta';
      title: string;
      description: string;
      index: boolean;
      noFollow: boolean;
      sitemap: boolean;
      link: {
        __typename?: 'FdrLink';
        openMethod?: Types.FdrLinkOpenMethod | null;
        legacyUrl?: string | null;
        type: Types.FdrLinkType;
        url: string;
      };
    } | null;
  };
  productInfoB2B?: {
    __typename?: 'ProductInfoB2B';
    route?: string | null;
    duration: string;
    priceFrom?: string | null;
    typeFlags?: Array<string> | null;
  } | null;
};

export const FdrGeoMapRoundTripFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fdrGeoMapRoundTrip' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FdrRoundTrip' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'id' },
            name: { kind: 'Name', value: 'publicId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'hero' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fdrImage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'resized' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'criteria' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'imageCriteria' },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'fdrResized' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'destination' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'id' },
                  name: { kind: 'Name', value: 'publicId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'coordinates' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'fdrCoordinates' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'webMeta' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fdrProductWebMeta' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productInfoB2B' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fdrProductInfoB2b' },
                },
              ],
            },
          },
        ],
      },
    },
    ...FdrImageFragmentDoc.definitions,
    ...FdrResizedFragmentDoc.definitions,
    ...FdrCoordinatesFragmentDoc.definitions,
    ...FdrProductWebMetaFragmentDoc.definitions,
    ...FdrProductInfoB2bFragmentDoc.definitions,
  ],
} as unknown as DocumentNode;
export const FdrGeoMapAdventureTravelFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'fdrGeoMapAdventureTravel' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'FdrAdventureTravel' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            alias: { kind: 'Name', value: 'id' },
            name: { kind: 'Name', value: 'publicId' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'headerImages' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fdrImage' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'resized' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'criteria' },
                      value: {
                        kind: 'Variable',
                        name: { kind: 'Name', value: 'imageCriteria' },
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'fdrResized' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'route' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fdrAdventureTravelRoute' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'webMeta' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fdrProductWebMeta' },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'productInfoB2B' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'FragmentSpread',
                  name: { kind: 'Name', value: 'fdrProductInfoB2b' },
                },
              ],
            },
          },
        ],
      },
    },
    ...FdrImageFragmentDoc.definitions,
    ...FdrResizedFragmentDoc.definitions,
    ...FdrAdventureTravelRouteFragmentDoc.definitions,
    ...FdrProductWebMetaFragmentDoc.definitions,
    ...FdrProductInfoB2bFragmentDoc.definitions,
  ],
} as unknown as DocumentNode;
export const FdrGeoMapProductsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'FdrGeoMapProducts' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'input' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'FdrGeoInput' },
            },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'productLimit' },
          },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } },
          },
        },
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'imageCriteria' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'ListType',
              type: {
                kind: 'NonNullType',
                type: {
                  kind: 'NamedType',
                  name: { kind: 'Name', value: 'FdrImageCriteria' },
                },
              },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'fdrGeo' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'input' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'id' },
                  name: { kind: 'Name', value: 'publicId' },
                },
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'FdrContinent' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'adventureTravels' },
                        name: { kind: 'Name', value: 'products' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'input' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'productTypes' },
                                  value: {
                                    kind: 'ListValue',
                                    values: [
                                      {
                                        kind: 'EnumValue',
                                        value: 'ADVENTURE_TRAVEL',
                                      },
                                    ],
                                  },
                                },
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'pagination' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'page' },
                                        value: { kind: 'IntValue', value: '0' },
                                      },
                                      {
                                        kind: 'ObjectField',
                                        name: {
                                          kind: 'Name',
                                          value: 'perPage',
                                        },
                                        value: {
                                          kind: 'Variable',
                                          name: {
                                            kind: 'Name',
                                            value: 'productLimit',
                                          },
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'productsPage' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '__typename' },
                                  },
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value: 'fdrGeoMapAdventureTravel',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'roundtrips' },
                        name: { kind: 'Name', value: 'products' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'input' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'productTypes' },
                                  value: {
                                    kind: 'ListValue',
                                    values: [
                                      { kind: 'EnumValue', value: 'ROUNDTRIP' },
                                    ],
                                  },
                                },
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'pagination' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'page' },
                                        value: { kind: 'IntValue', value: '0' },
                                      },
                                      {
                                        kind: 'ObjectField',
                                        name: {
                                          kind: 'Name',
                                          value: 'perPage',
                                        },
                                        value: {
                                          kind: 'Variable',
                                          name: {
                                            kind: 'Name',
                                            value: 'productLimit',
                                          },
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'productsPage' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '__typename' },
                                  },
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value: 'fdrGeoMapRoundTrip',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'FdrCountryGroup' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'adventureTravels' },
                        name: { kind: 'Name', value: 'products' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'input' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'productTypes' },
                                  value: {
                                    kind: 'ListValue',
                                    values: [
                                      {
                                        kind: 'EnumValue',
                                        value: 'ADVENTURE_TRAVEL',
                                      },
                                    ],
                                  },
                                },
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'pagination' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'page' },
                                        value: { kind: 'IntValue', value: '0' },
                                      },
                                      {
                                        kind: 'ObjectField',
                                        name: {
                                          kind: 'Name',
                                          value: 'perPage',
                                        },
                                        value: {
                                          kind: 'Variable',
                                          name: {
                                            kind: 'Name',
                                            value: 'productLimit',
                                          },
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'productsPage' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '__typename' },
                                  },
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value: 'fdrGeoMapAdventureTravel',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'roundtrips' },
                        name: { kind: 'Name', value: 'products' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'input' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'productTypes' },
                                  value: {
                                    kind: 'ListValue',
                                    values: [
                                      { kind: 'EnumValue', value: 'ROUNDTRIP' },
                                    ],
                                  },
                                },
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'pagination' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'page' },
                                        value: { kind: 'IntValue', value: '0' },
                                      },
                                      {
                                        kind: 'ObjectField',
                                        name: {
                                          kind: 'Name',
                                          value: 'perPage',
                                        },
                                        value: {
                                          kind: 'Variable',
                                          name: {
                                            kind: 'Name',
                                            value: 'productLimit',
                                          },
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'productsPage' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '__typename' },
                                  },
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value: 'fdrGeoMapRoundTrip',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'FdrCountry' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'adventureTravels' },
                        name: { kind: 'Name', value: 'products' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'input' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'productTypes' },
                                  value: {
                                    kind: 'ListValue',
                                    values: [
                                      {
                                        kind: 'EnumValue',
                                        value: 'ADVENTURE_TRAVEL',
                                      },
                                    ],
                                  },
                                },
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'pagination' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'page' },
                                        value: { kind: 'IntValue', value: '0' },
                                      },
                                      {
                                        kind: 'ObjectField',
                                        name: {
                                          kind: 'Name',
                                          value: 'perPage',
                                        },
                                        value: {
                                          kind: 'Variable',
                                          name: {
                                            kind: 'Name',
                                            value: 'productLimit',
                                          },
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'productsPage' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '__typename' },
                                  },
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value: 'fdrGeoMapAdventureTravel',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'roundtrips' },
                        name: { kind: 'Name', value: 'products' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'input' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'productTypes' },
                                  value: {
                                    kind: 'ListValue',
                                    values: [
                                      { kind: 'EnumValue', value: 'ROUNDTRIP' },
                                    ],
                                  },
                                },
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'pagination' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'page' },
                                        value: { kind: 'IntValue', value: '0' },
                                      },
                                      {
                                        kind: 'ObjectField',
                                        name: {
                                          kind: 'Name',
                                          value: 'perPage',
                                        },
                                        value: {
                                          kind: 'Variable',
                                          name: {
                                            kind: 'Name',
                                            value: 'productLimit',
                                          },
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'productsPage' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '__typename' },
                                  },
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value: 'fdrGeoMapRoundTrip',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'FdrRegion' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'adventureTravels' },
                        name: { kind: 'Name', value: 'products' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'input' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'productTypes' },
                                  value: {
                                    kind: 'ListValue',
                                    values: [
                                      {
                                        kind: 'EnumValue',
                                        value: 'ADVENTURE_TRAVEL',
                                      },
                                    ],
                                  },
                                },
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'pagination' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'page' },
                                        value: { kind: 'IntValue', value: '0' },
                                      },
                                      {
                                        kind: 'ObjectField',
                                        name: {
                                          kind: 'Name',
                                          value: 'perPage',
                                        },
                                        value: {
                                          kind: 'Variable',
                                          name: {
                                            kind: 'Name',
                                            value: 'productLimit',
                                          },
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'productsPage' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '__typename' },
                                  },
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value: 'fdrGeoMapAdventureTravel',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        alias: { kind: 'Name', value: 'roundtrips' },
                        name: { kind: 'Name', value: 'products' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'input' },
                            value: {
                              kind: 'ObjectValue',
                              fields: [
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'productTypes' },
                                  value: {
                                    kind: 'ListValue',
                                    values: [
                                      { kind: 'EnumValue', value: 'ROUNDTRIP' },
                                    ],
                                  },
                                },
                                {
                                  kind: 'ObjectField',
                                  name: { kind: 'Name', value: 'pagination' },
                                  value: {
                                    kind: 'ObjectValue',
                                    fields: [
                                      {
                                        kind: 'ObjectField',
                                        name: { kind: 'Name', value: 'page' },
                                        value: { kind: 'IntValue', value: '0' },
                                      },
                                      {
                                        kind: 'ObjectField',
                                        name: {
                                          kind: 'Name',
                                          value: 'perPage',
                                        },
                                        value: {
                                          kind: 'Variable',
                                          name: {
                                            kind: 'Name',
                                            value: 'productLimit',
                                          },
                                        },
                                      },
                                    ],
                                  },
                                },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'productsPage' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: '__typename' },
                                  },
                                  {
                                    kind: 'FragmentSpread',
                                    name: {
                                      kind: 'Name',
                                      value: 'fdrGeoMapRoundTrip',
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    ...FdrGeoMapAdventureTravelFragmentDoc.definitions,
    ...FdrGeoMapRoundTripFragmentDoc.definitions,
  ],
} as unknown as DocumentNode;

/**
 * __useFdrGeoMapProductsQuery__
 *
 * To run a query within a React component, call `useFdrGeoMapProductsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFdrGeoMapProductsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFdrGeoMapProductsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      productLimit: // value for 'productLimit'
 *      imageCriteria: // value for 'imageCriteria'
 *   },
 * });
 */
export function useFdrGeoMapProductsQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    FdrGeoMapProductsQuery,
    FdrGeoMapProductsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useQuery<
    FdrGeoMapProductsQuery,
    FdrGeoMapProductsQueryVariables
  >(FdrGeoMapProductsDocument, options);
}
export function useFdrGeoMapProductsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    FdrGeoMapProductsQuery,
    FdrGeoMapProductsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return ApolloReactHooks.useLazyQuery<
    FdrGeoMapProductsQuery,
    FdrGeoMapProductsQueryVariables
  >(FdrGeoMapProductsDocument, options);
}
export type FdrGeoMapProductsQueryHookResult = ReturnType<
  typeof useFdrGeoMapProductsQuery
>;
export type FdrGeoMapProductsLazyQueryHookResult = ReturnType<
  typeof useFdrGeoMapProductsLazyQuery
>;
export type FdrGeoMapProductsQueryResult = Apollo.QueryResult<
  FdrGeoMapProductsQuery,
  FdrGeoMapProductsQueryVariables
>;
